export default __webpack_public_path__ + "static/media/scan-icon.a30131e6.svg";